<script>
/* eslint-disable */
export default {
  data() {
    return {};
  },
  methods: {},
};
</script>
<style lang="scss">
.learn-form {
  border-radius: 0.25rem;
  -webkit-box-shadow: 0px 20px 20px #00000029;
  box-shadow: 0px 20px 20px #00000029;
}
</style>
<template>
  <div class="bg-white learn-form">
    <div class="py-5 px-5">
      <div class="container">
        <b-form>
          <div class="row mt-2">
            <div class="col-md-6">
              <b-form-group label="WORDPRESS POST ID" label-for="learn_id">
                <div class="d-flex">
                  <b-form-input></b-form-input>
                  <b-button variant="outline-primary" class="ml-2"
                    >ADD</b-button
                  >
                </div>
              </b-form-group>
            </div>

            <div class="col-md-6 pl-5"></div>
          </div>
        </b-form>
      </div>
    </div>
  </div>
</template>